/* v3-fixed */
/* Cerrar drawer al cargar/restaurar p�gina (previene bfcache con drawer abierto) */
window.addEventListener('pageshow', function() {
  var cd = document.querySelector('cart-drawer');
  if (cd) {
    cd.classList.remove('active', 'animate');
    cd.style.visibility = '';
    document.body.classList.remove('overflow-hidden');
  }
});

(function () {
  var root = document.querySelector('.landing-noella');
  if (!root) return;

  /* ?? PRODUCT DATA ?? */
  var productJsonEl = root.querySelector('#noella-product-json');
  var productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;

  function getVariantId(color, size) {
    if (!productData) return null;
    var v = productData.variants.find(function (vr) {
      return vr.option1 === color && vr.option2 === size;
    });
    return v ? v.id : null;
  }

  /* ?? GALLERY ?? */
  var mainImg = root.querySelector('#noella-main-img');
  var thumbs = root.querySelectorAll('.noella-gallery__thumb');
  var galleryDots = root.querySelectorAll('.noella-gallery__dot');
  var currentThumb = 0;

  function setActiveThumb(i) {
    currentThumb = i;
    thumbs.forEach(function (t, idx) { t.classList.toggle('active', idx === i); });
    galleryDots.forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
    var thumb = thumbs[i];
    if (mainImg && thumb) {
      mainImg.classList.add('fading');
      setTimeout(function () {
        mainImg.src = thumb.dataset.full;
        mainImg.classList.remove('fading');
      }, 200);
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { setActiveThumb(i); });
  });
  galleryDots.forEach(function (d, i) {
    d.addEventListener('click', function () { setActiveThumb(i); });
  });

  /* swipe on mobile */
  var galleryMain = root.querySelector('.noella-gallery__main');
  if (galleryMain) {
    var startX = 0;
    galleryMain.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    galleryMain.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) {
        var next = dx < 0
          ? (currentThumb + 1) % thumbs.length
          : (currentThumb - 1 + thumbs.length) % thumbs.length;
        setActiveThumb(next);
      }
    }, { passive: true });
  }

  /* ?? COLOR SELECTOR ?? */
  var colorBtns = root.querySelectorAll('.noella-color-btn');
  var selectedColor = colorBtns.length > 0 ? colorBtns[0].dataset.color : null;
  var colorLabel = root.querySelector('.noella-option__selected--color');

  colorBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      colorBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      selectedColor = btn.dataset.color;
      if (colorLabel) colorLabel.textContent = selectedColor;
      syncBundleSelects('color', selectedColor);
    });
  });

  /* ?? SIZE SELECTOR ?? */
  var sizeBtns = root.querySelectorAll('.noella-size-btn');
  var selectedSize = sizeBtns.length > 0 ? sizeBtns[0].dataset.size : null;
  var sizeLabel = root.querySelector('.noella-option__selected--size');

  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sizeBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      selectedSize = btn.dataset.size;
      if (sizeLabel) sizeLabel.textContent = selectedSize;
      syncBundleSelects('size', selectedSize);
    });
  });

  /* sync the first row of bundle selects with top-level color/size picks */
  function syncBundleSelects(type, val) {
    var activeTier = root.querySelector('.noella-tier.selected');
    if (!activeTier) return;
    var selects = activeTier.querySelectorAll(type === 'color' ? '.noella-item-color' : '.noella-item-size');
    if (selects.length > 0) selects[0].value = val;
  }

  /* ?? BUNDLE TIER SELECTION ?? */
  var tiers = root.querySelectorAll('.noella-tier');

  function selectTier(tier) {
    tiers.forEach(function (t) { t.classList.remove('selected'); });
    tier.classList.add('selected');
    proxyKaching(tier);
  }

  tiers.forEach(function (tier) {
    /* mousedown fires before Kaching can intercept the click */
    tier.addEventListener('mousedown', function (e) {
      /* Don't intercept native SELECT interactions */
      if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
      selectTier(tier);
    });
    /* Also handle touch */
    tier.addEventListener('touchstart', function (e) {
      if (e.target.tagName === 'SELECT') return;
      selectTier(tier);
    }, { passive: true });
  });

  /* Kaching Bundles bridge - proxies our tier selection to Kaching's widget */
  function proxyKaching(tier) {
    var qty = parseInt(tier.dataset.qty) || 1;
    /* Kaching renders offer items - try multiple selectors */
    var kachingOffers = document.querySelectorAll(
      '[data-offer-quantity], [data-quantity], .kaching-offer-item, [id*="kaching"] [role="radio"], [id*="kaching"] input[type="radio"]'
    );
    if (!kachingOffers.length) return;
    kachingOffers.forEach(function (el) {
      var offerQty = parseInt(el.dataset.offerQuantity || el.dataset.quantity || el.value || '0');
      if (offerQty === qty) {
        el.click();
      }
    });
  }

  /* ?? ATC ?? */
  var atcBtn = root.querySelector('.noella-atc-btn');
  if (atcBtn) {
    atcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var activeTier = root.querySelector('.noella-tier.selected');
      if (!activeTier) return;

      var qty = parseInt(activeTier.dataset.qty) || 1;
      var colorSels = activeTier.querySelectorAll('.noella-item-color');
      var sizeSels = activeTier.querySelectorAll('.noella-item-size');

      /* Single tier: read from the tier's own selects */
      if (qty === 1) {
        var colorSel0 = activeTier.querySelector('.noella-item-color');
        var sizeSel0 = activeTier.querySelector('.noella-item-size');
        var c0 = colorSel0 ? colorSel0.value : selectedColor;
        var s0 = sizeSel0 ? sizeSel0.value : selectedSize;
        var vid = getVariantId(c0, s0);
        if (!vid) { alert('Selecciona color y talla'); return; }
        addToCart([{ id: vid, quantity: 1 }]);
        return;
      }

      /* Bundle: 1 �tem pagado + (qty-1) �tems regalo a $0, cada uno con su color/talla */
      var BUNDLE_VARIANT_IDS = { 4: 44598392979545, 8: 44598393012313 };
      var REGALO_VARIANT_ID = 44598581297241;
      var bundleVid = BUNDLE_VARIANT_IDS[qty];
      if (!bundleVid) { alert('Pack no disponible'); return; }

      var items = [];
      for (var i = 0; i < qty; i++) {
        var color = colorSels[i] ? colorSels[i].value : selectedColor;
        var size = sizeSels[i] ? sizeSels[i].value : selectedSize;
        items.push({
          id: i === 0 ? bundleVid : REGALO_VARIANT_ID,
          quantity: 1,
          properties: { 'Color': color, 'Talla': size, '_n': String(i + 1) }
        });
      }

      addToCart(items);
    }, true); /* capture:true -- fires before Kaching */
  }

  /* Inyecta regla CSS que gana sobre cualquier style del drawer */
  function ensureDrawerVisibleCSS() {
    if (document.getElementById('_n_drawer_fix')) return;
    var s = document.createElement('style');
    s.id = '_n_drawer_fix';
    s.textContent = 'cart-drawer.active.animate{visibility:visible!important} .cart-drawer .drawer__inner{display:flex!important;flex-direction:column!important;height:100%!important;overflow:hidden!important} .cart-drawer .cart-drawer__body{flex:1 1 0%!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;overscroll-behavior:contain!important;min-height:0!important} .cart-drawer .drawer__footer{flex-shrink:0!important}';
    document.head.appendChild(s);
  }

  function openDrawerManually(cartDrawer) {
    ensureDrawerVisibleCSS();
    cartDrawer.classList.remove('is-empty');
    cartDrawer.classList.add('animate', 'active');
    cartDrawer.style.visibility = 'visible';
    document.body.classList.add('overflow-hidden');

    /* MutationObserver: limpia overflow-hidden cuando Kaching cierra el drawer (bot�n X, overlay, ESC) */
    if (!cartDrawer._noellaObserver) {
      cartDrawer._noellaObserver = new MutationObserver(function() {
        if (!cartDrawer.classList.contains('active')) {
          document.body.classList.remove('overflow-hidden');
          cartDrawer.style.visibility = '';
        }
      });
      cartDrawer._noellaObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    /* Ensure visibility survives any deferred style override */
    setTimeout(function() { cartDrawer.style.visibility = 'visible'; }, 10);
    setTimeout(function() { cartDrawer.style.visibility = 'visible'; }, 100);
    setTimeout(function() { cartDrawer.style.visibility = 'visible'; }, 300);
  }

  function addToCart(items) {
    var btn = atcBtn;
    var orig = btn.textContent;
    btn.textContent = 'Agregando...';
    btn.disabled = true;

    fetch('/cart/add.js?kaching_bundles=true', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'] })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.description && data.description.toLowerCase().includes('error')) throw new Error(data.description);
      btn.textContent = '�Agregado!';
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && data.sections && data.sections['cart-drawer']) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
        var newInner = doc.querySelector('.drawer__inner');
        var curInner = cartDrawer.querySelector('.drawer__inner');
        if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
        var iconEl = document.getElementById('cart-icon-bubble');
        if (iconEl && data.sections['cart-icon-bubble']) {
          var iconDoc = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          if (iconDoc.body) iconEl.innerHTML = iconDoc.body.innerHTML;
        }
        openDrawerManually(cartDrawer);
      }
      setTimeout(function() { btn.textContent = orig; btn.disabled = false; }, 2500);
    })
    .catch(function(err) {
      console.error(err);
      btn.textContent = 'Error - Intentar de nuevo';
      btn.disabled = false;
      setTimeout(function() { btn.textContent = orig; }, 3000);
    });
  }

  /* ?? ACCORDIONS ?? */
  root.querySelectorAll('.noella-accordion__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.noella-accordion__item');
      var content = item.querySelector('.noella-accordion__content');
      var isOpen = item.classList.contains('open');
      root.querySelectorAll('.noella-accordion__item').forEach(function (el) {
        el.classList.remove('open');
        el.querySelector('.noella-accordion__content').style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  /* ?? REVIEWS CAROUSEL ?? */
  var track = root.querySelector('.noella-reviews__track');
  var reviewDots = root.querySelectorAll('.noella-reviews__dot');
  var totalReviews = reviewDots.length;
  var currentReview = 0;

  function goToReview(i) {
    currentReview = (i + totalReviews) % totalReviews;
    if (track) track.style.transform = 'translateX(-' + currentReview * 100 + '%)';
    reviewDots.forEach(function (d, idx) { d.classList.toggle('active', idx === currentReview); });
  }

  var prevBtn = root.querySelector('.noella-reviews__prev');
  var nextBtn = root.querySelector('.noella-reviews__next');
  if (prevBtn) prevBtn.addEventListener('click', function () { goToReview(currentReview - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goToReview(currentReview + 1); });
  reviewDots.forEach(function (d, i) { d.addEventListener('click', function () { goToReview(i); }); });

  var autoReview = setInterval(function () { goToReview(currentReview + 1); }, 5000);
  if (track) {
    track.addEventListener('mouseenter', function () { clearInterval(autoReview); });
    track.addEventListener('mouseleave', function () {
      autoReview = setInterval(function () { goToReview(currentReview + 1); }, 5000);
    });
  }

  /* touch swipe on reviews */
  if (track) {
    var rStartX = 0;
    track.addEventListener('touchstart', function (e) { rStartX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - rStartX;
      if (Math.abs(dx) > 40) goToReview(currentReview + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* ?? COUNTDOWN TIMER ?? */
  var noellaTimerNums = root.querySelectorAll('.noella-timer-num');
  if (noellaTimerNums.length >= 3) {
    var noellaEnd = Date.now() + (9 * 3600 + 2 * 60 + 19) * 1000;
    function noellaTick() {
      var diff = Math.max(0, noellaEnd - Date.now());
      noellaTimerNums[0].textContent = String(Math.floor(diff / 3600000)).padStart(2, '0');
      noellaTimerNums[1].textContent = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
      noellaTimerNums[2].textContent = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
      if (diff > 0) setTimeout(noellaTick, 1000);
    }
    noellaTick();
  }

  /* ?? SCROLL REVEAL ?? */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    root.querySelectorAll('.noella-reveal, .noella-reveal-left, .noella-reveal-right').forEach(function (el) {
      observer.observe(el);
    });
  } else {
    /* fallback: show everything */
    root.querySelectorAll('.noella-reveal, .noella-reveal-left, .noella-reveal-right').forEach(function (el) {
      el.classList.add('visible');
    });
  }
})();
